import { CheckGradient, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { upsellBlock } from 'blocks/OnboardingWizard/utils';

export interface ProFeatureListProps {}

const FEATURES = [
  'Larger file sizes',
  'Automated Transcriptions',
  'Unlimited Captions',
  'Saved Templates',
  'Custom Design Assets',
];

const ProFeatureList: React.FC<ProFeatureListProps> = () => (
  <ul className={upsellBlock('feature-list')}>
    {FEATURES.map(feature => (
      <Spacer
        align="center"
        as="li"
        className={upsellBlock('feature-row')}
        justify="space-between"
        key={feature}
        orientation="horizontal"
      >
        {feature}
        <CheckGradient />
      </Spacer>
    ))}
  </ul>
);

export default ProFeatureList;
